import { Chapter } from '@core/types';
import { useEffect, useRef } from 'react';
import { CurrentChapterIndicator } from '../CurrentChapterIndicator';

export const ChapterContainer = ({
    chapter,
    activeChapter,
    onChapterClick
}: {
    onChapterClick?: (chapter: Chapter) => void;
    chapter: Chapter;
    activeChapter: Chapter | null | undefined;
}) => {
    const chapterRef = useRef<HTMLLIElement>(null);
    const isActiveChapter = chapter.chapterId === activeChapter?.chapterId;
    const isChapterClickable = !!onChapterClick && !isActiveChapter;

    useEffect(() => {
        if (!chapterRef.current) return;
        if (!activeChapter) return;
        if (chapter.chapterId === activeChapter.chapterId) {
            chapterRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
    }, [chapterRef.current, chapter, activeChapter]);

    return (
        <li
            data-cy="chapter"
            data-testid="chapterItem"
            className={`relative first:rounded-t-lg last:rounded-b-lg leading-5 ${isActiveChapter && 'font-medium overflow-hidden'}`}
            ref={chapterRef}
        >
            {isActiveChapter && <CurrentChapterIndicator />}
            {isChapterClickable ? (
                <a
                    className="bg-white focus-visible:bg-transparent hover:bg-transparent rounded-sm cursor-pointer block px-4 py-2 transition-colors ease-in-out duration-200"
                    onClick={() => onChapterClick(chapter)}
                    data-testid="chapterLink"
                >
                    {chapter.chapterTitle}
                </a>
            ) : (
                <span className="bg-white block px-4 py-2" data-testid="chapterNotALink">
                    {chapter.chapterTitle}
                </span>
            )}
        </li>
    );
};
